//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import $ from "jquery";

import _ from "js/underscore-mixins";

(function() {
    // Take an RGB hex code and an opacity value, and return the corresponding rgba(...) string
    // https://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
  const hexA = function(hex, opacity) {
    const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, (m, r, g, b) => {
      return r + r + g + g + b + b;
    });
    const [, r, g, b] = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return b ? `rgba(${parseInt(r, 16)}, ${parseInt(g, 16)}, ${parseInt(b, 16)}, ${opacity})` : null;
  };

    // While this directive is loosely modeled after areaChart, highcharts-ng doesn't play nicely with multiple series/axes.
  angular.module('curalate').component('gainLossChart', {
    bindings: {
      chartContainerId: '@',
      data: '<',
      showLabels: '<?',
    },
    template: '<div id="{{$ctrl.chartContainerId}}"></div>',
    controller: ['$filter', '$scope', 'CHART_COLORS',
      function($filter, $scope, CHART_COLORS) {
        const MAX_DATA_LABELS = 15;
        const getHighchartOptions = function(data, showLabels) {
          let pointRadius;

          if (!data.categories || !data.units || !data.gains || !data.losses || !data.deltas || !data.totals) {
            return null;
          }

                    // This logic is adapted from charts.area.js
          const interval = (data.categories.length > 20) ? Math.round(data.categories.length / 20) : 1;

                    // Ditto
          if (data.categories.length > 120) {
            pointRadius = 1;
          } else if (data.categories.length > 90) {
            pointRadius = 2;
          } else if (data.categories.length > 60) {
            pointRadius = 3;
          } else {
            pointRadius = 4;
          }

                    // If seven or less items in the x-axis, render labels for each. Otherwise, only render the first and last.
          function xAxisLabelFormatter() {
            const labelsEnabled = this.axis.options.labels.enabled;
            if (labelsEnabled) {
              if (this.isFirst || this.isLast || this.axis.categories.length <= 7) {
                return this.axis.defaultLabelFormatter.call(this);
              }
            }
            return null;
          }

          function yAxisLabelFormatter() {
            return $filter('readableNumber')(this.value);
          }

          function generateChangeText(number, units, percent, prefixSign) {
                        // units, percent, and prefixSign are optional parameters
            const sign = (Math.sign(number) < 0) ? '-' : '+';
            const absNum = Math.abs(number);
            const absPct = Math.abs(percent);

            const prefixText = prefixSign ? `${sign} ` : '';
            const numText = CURALATE.misc.renderToReadableNumber(null, absNum);
            const unitsText = units ? ` ${units}` : '';
            const percentText = percent ? ` (${sign} ${absPct.toFixed(2)}%)` : '';

            return `${prefixText}${numText}${unitsText}${percentText}`;
          }

          function generateChangeTextForDataLabel(number, percent) {
            // units, percent, and prefixSign are optional parameters
            const sign = (Math.sign(number) < 0) ? '-' : '+';
            const absNum = Math.abs(number);
            const absPct = Math.abs(percent);

            const prefixText = `${sign}`;
            const numText = CURALATE.misc.renderToReadableNumber(null, absNum);
            const percentText = percent ? ` (${absPct.toFixed(2)}%)` : '';

            return `${prefixText}${numText}${percentText}`;
          }

          const tooltipFormatter = function() {
            const points = this.points;

            // If this is Full Access, points = [gain, loss, delta]
            // If this is Basic Access, points = [delta]
            const delta = points.pop();
            const loss = points.pop();
            const gain = points.pop();

            const idx = delta.point.index;
            const total = data.totals.data[idx];

            const prev = total - delta.y;
            const pctGrowth = gain ? (gain.y / prev) * 100 : 0;
            const pctLoss = loss ? ((0 - loss.y) / prev) * 100 : 0;

            const gainText = (gain) ? `${generateChangeText(gain.y, `${data.units} Gained`, pctGrowth, false)}<br/>` : '';
            const lossText = (loss) ? `${generateChangeText(loss.y, `${data.units} Lost`, pctLoss, false)}<br />` : '';

            const changeText = generateChangeText(delta.y, data.units, null, true);
            const deltaText = `Change: ${changeText}`;

            const tooltipText = `<strong style="color:${CHART_COLORS['@oyster']}">${this.x}</strong><br/>${gainText}${lossText}${deltaText}`;

            return tooltipText;
          };

          const dataLabelFormatter = function() {
            // Only show percentages on the column data labels
            if (this.point.shapeType === 'rect') {
              const index = this.point.index;
              const total = data.totals.data[index];
              const percentChange = (this.point.y / total) * 100;

              return generateChangeTextForDataLabel(this.point.y, percentChange);
            } else {
              return $filter('readableNumber')(this.point.y);
            }
          };

          const chartConfigSeries = [{ // Delta
            color: CHART_COLORS['@oreo'],
            data: data.deltas.data,
            marker: {
              radius: pointRadius,
            },
            name: data.deltas.label,
            type: 'spline',
          }];

          if (data.losses && data.losses.data && !isNaN(data.losses.data[0])) {
            chartConfigSeries.unshift({ // Lost
              color: hexA(CHART_COLORS['@guacamole'], 0.25),
              data: data.losses.data,
              name: data.losses.label,
              type: 'column',
            });
          }

          if (data.gains && data.gains.data && !isNaN(data.gains.data[0])) {
            chartConfigSeries.unshift({ // Gain
              color: CHART_COLORS['@guacamole'],
              data: data.gains.data,
              name: data.gains.label,
              type: 'column',
            });
          }

          const numDataPoints = (data.categories || []).length;

          const chartConfig = {
            chart: {
              zoomType: 'xy',
              height: showLabels ? 600 : null,
              width: showLabels ? 920 : null,
              marginTop: showLabels ? 80 : null,
            },
            credits: {
              enabled: false,
            },
            legend: {
              align: showLabels ? 'right' : 'left',
              verticalAlign: 'top',
            },
            plotOptions: {
              series: {
                stacking: 'normal',
                dataLabels: {
                  enabled: showLabels && numDataPoints <= MAX_DATA_LABELS,
                  color: CHART_COLORS['@oreo'],
                  style: {
                    textOutline: 'none',
                  },
                  formatter: dataLabelFormatter,
                },
                enableMouseTracking: !showLabels,
              },
              column: {
                stacking: 'normal',
                dataLabels: {
                  enabled: showLabels && numDataPoints <= MAX_DATA_LABELS,
                  inside: false,
                  color: CHART_COLORS['@oreo'],
                  style: {
                    textOutline: 'none',
                  },
                  formatter: dataLabelFormatter,
                },
                enableMouseTracking: !showLabels,
              },
            },
            series: chartConfigSeries,
            title: {
              text: null,
            },
            tooltip: {
              backgroundColor: CHART_COLORS['@oreo'],
              shared: true,
              followPointer: false,
              formatter: tooltipFormatter,
              style: {
                color: '#ffffff',
              },
            },
            xAxis: {
              categories: data.categories,
              crosshair: false,
              labels: {
                formatter: xAxisLabelFormatter,
              },
              tickInterval: interval,
            },
            yAxis: {
              title: {
                text: null,
              },
              reversed: false,
              labels: {
                step: 1,
                formatter: yAxisLabelFormatter,
              },
            },
          };

          return chartConfig;
        };

                // Update the chart whenever chart data changes
        this.$onChanges = () => {
          if (_.isEmpty(this.data)) {
            return;
          }
          const opts = getHighchartOptions(this.data, !!this.showLabels);
          $(`#${this.chartContainerId}`).highcharts(opts);
        };
      },
    ],
  });
})();
